module.exports = __webpack_public_path__ + "img/WorkSans-Bold.26bd98e.svg";